/* aviso "online agora" do suporte: compara a hora de brasilia com o horario de atendimento das configuracoes do
   tema (data-abre, data-fecha, data-fds no elemento). fechado, diz quando volta. sem js fica o texto neutro do html */
(function () {
  // capa e quadro de horario carregam o mesmo arquivo: roda uma vez so e cuida dos dois avisos
  if (window.ntSupStatus) return;
  window.ntSupStatus = true;
  var DIAS = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];
  var CURTO = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  function agora() {
    var partes = {};
    try {
      new Intl.DateTimeFormat('en-US', { timeZone: 'America/Sao_Paulo', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
        .formatToParts(new Date())
        .forEach(function (p) { partes[p.type] = p.value; });
    } catch (e) {
      var d = new Date();
      return { dia: d.getDay(), hora: d.getHours() + d.getMinutes() / 60 };
    }
    var h = parseInt(partes.hour, 10) % 24;
    return { dia: CURTO[partes.weekday], hora: h + parseInt(partes.minute, 10) / 60 };
  }

  function atende(dia, fds) { return fds || (dia >= 1 && dia <= 5); }

  function quando(t, abre, fds) {
    var hora = abre + 'h';
    if (atende(t.dia, fds) && t.hora < abre) return 'hoje às ' + hora;
    for (var i = 1; i <= 7; i++) {
      var d = (t.dia + i) % 7;
      if (atende(d, fds)) return (i === 1 ? 'amanhã' : DIAS[d]) + ' às ' + hora;
    }
    return '';
  }

  function atualiza(el) {
    var abre = parseInt(el.getAttribute('data-abre'), 10);
    var fecha = parseInt(el.getAttribute('data-fecha'), 10);
    var fds = el.getAttribute('data-fds') === '1';
    if (isNaN(abre) || isNaN(fecha)) return;
    var t = agora();
    var online = atende(t.dia, fds) && t.hora >= abre && t.hora < fecha;
    el.setAttribute('data-estado', online ? 'online' : 'offline');
    var estado = el.querySelector('[data-nt-sup-estado]');
    if (estado) {
      var txt = estado.getAttribute(online ? 'data-online' : 'data-offline');
      if (txt) estado.textContent = txt;
    }
    var volta = el.querySelector('[data-nt-sup-volta]');
    if (volta) {
      var molde = volta.getAttribute('data-texto') || '';
      var q = online ? '' : quando(t, abre, fds);
      volta.textContent = online || !q ? '' : molde.replace('{quando}', q);
      volta.hidden = online || !q;
    }
  }

  function tudo() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-nt-sup-status]'), atualiza);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tudo);
  else tudo();
  setInterval(tudo, 60000);
  document.addEventListener('shopify:section:load', tudo);
})();
